import { BlogPostsListResponse, BlogPostType, BlogTagType } from '@screens/Blog/model/types/blog';
import { ProductCardType, ProductRatingsType, ProductsType } from '@shared/types/product';
import { fetchServerData } from '@shared/utils/fetchServerData/fetchServerData';
import { getProductCardData } from '@shared/utils/getProductCardData/getProductCardData';

import { normalizeBlogPosts } from '../lib/normalizeBlogPosts';

type GetBlogPostsParams = {
  tagSlug?: string;
  take?: number;
  skip?: number;
};

type BlogPostProductsResponse = {
  products?: ProductsType;
  ratings?: ProductRatingsType;
};

export const getBlogTags = async (): Promise<BlogTagType[]> => {
  const response = await fetchServerData<BlogTagType[]>('v2/blog/tag');

  return response.data || [];
};

export const getBlogPosts = async ({ tagSlug, take = 1000, skip = 0 }: GetBlogPostsParams = {}): Promise<
  BlogPostType[]
> => {
  const params = new URLSearchParams({
    take: String(take),
    skip: String(skip)
  });
  const url = tagSlug ? `v2/blog/post/by-tag/${tagSlug}?${params}` : `v2/blog/post?${params}`;
  const response = await fetchServerData<BlogPostType[] | BlogPostsListResponse>(url);

  return normalizeBlogPosts(response.data);
};

export const getBlogPostBySlug = async (slug: string): Promise<BlogPostType | null> => {
  const response = await fetchServerData<BlogPostType>(`v2/blog/post/by-slug/${encodeURIComponent(slug)}`);

  return response.data || null;
};

export const getBlogPostProducts = async (postId: string, take = 10, skip = 0): Promise<ProductCardType[]> => {
  const params = new URLSearchParams({
    take: String(take),
    skip: String(skip)
  });
  const response = await fetchServerData<BlogPostProductsResponse>(
    `v2/blog/post/${encodeURIComponent(postId)}/products?${params}`
  );

  return getProductCardData(response.data?.products || {}, response.data?.ratings);
};
